var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReportIconActive = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 6.6 0 13.2 0 20 C-5.28 20 -10.56 20 -16 20 C-16 13.4 -16 6.8 -16 0 C-9.17621463 -2.27459512 -6.67577028 -1.66894257 0 0 Z M-8 -1 C-8 -0.34 -8 0.32 -8 1 C-8.99 1.495 -8.99 1.495 -10 2 C-8.68 1.67 -7.36 1.34 -6 1 C-6.66 0.34 -7.32 -0.32 -8 -1 Z M-14 2 C-14 7.61 -14 13.22 -14 19 C-9.71 19 -5.42 19 -1 19 C-1 13.39 -1 7.78 -1 2 C-1.99 2 -2.98 2 -4 2 C-4 2.66 -4 3.32 -4 4 C-6.64 4 -9.28 4 -12 4 C-12 3.34 -12 2.68 -12 2 C-12.66 2 -13.32 2 -14 2 Z ",
    fill: "#80BD01",
    transform: "translate(19,2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.63 0 7.26 0 11 0 C11 0.66 11 1.32 11 2 C7.37 2 3.74 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#80BD01",
    transform: "translate(6,17)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.63 0 7.26 0 11 0 C11 0.66 11 1.32 11 2 C7.37 2 3.74 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#80BD01",
    transform: "translate(6,14)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.63 0 7.26 0 11 0 C11 0.66 11 1.32 11 2 C7.37 2 3.74 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#80BD01",
    transform: "translate(6,11)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.63 0 7.26 0 11 0 C11 0.66 11 1.32 11 2 C7.37 2 3.74 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#80BD01",
    transform: "translate(6,7)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReportIconActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/report-icon-active.cc9d02b1298023c2162fa290407a4127.svg";